import React from "react";
import "./AccountManagement.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { logoutUser } from "../../../features/admin/auth/Slice";

const accountData = [
  {
    id: 1,
    icon: "/images/profile/profile.png",
    title: "Profile Settings",
    desc: "Update your personal details & manage your account preferences.",
    route: "/profile-settings",
  },
  {
    id: 2,
    icon: "/images/profile/order-history.png",
    title: "Order History",
    desc: "View all your past orders and their current status.",
    route: "/order-history",
  },
  {
    id: 3,
    icon: "/images/profile/notification.png",
    title: "Notifications",
    desc: "Check the latest updates related to your account.",
    route: "/notification",
  },
    {
    id: 3,
    icon: "/images/profile/wallet2.png",
    title: "Wallet History",
    desc: "View all your wallet history",
    route: "/wallet-history",
  },
  // {
  //   id: 4,
  //   icon: "/images/profile/community.png",
  //   title: "Our Community",
  //   desc: "Building health, income, and trust as one network.",
  //   route: "/our-community",
  //   highlight: true,
  // },
];

const AccountManagement = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

  const isMobile = window.innerWidth <= 768;

  const handleNavigation = (item) => {
    if (item.route) {
      navigate(item.route);
    }
  };

  return (
    <div className="account-section container px-5">
      <h4 className="account-heading">Account Management</h4>

      <div className="account-grid">
        {accountData.map((item) => (
          <div
            key={item.id}
            className={`account-card ${item.highlight ? "highlight" : ""}`}
            onClick={() => handleNavigation(item)}
          >
            <div className="card-arrow">
              <FontAwesomeIcon className="arrow" icon={faArrowRight} />
            </div>

            <div className="card-icon">
              <img src={item.icon} alt="not" />
            </div>

            <h5>{item.title}</h5>
            <p>{item.desc}</p>
          </div>
        ))}
      </div>

      <div
        className="logout-wrapper"
        onClick={() => setShowLogoutConfirm(true)} // ✅ always open confirm
      >
        <div className="logout-text">Do you want to log out now?</div>

        {/* ✅ SHOW ONLY WHEN CONFIRM IS TRUE */}
        {showLogoutConfirm && (
          <div className="logout-actions">
            <button
              className="cancel-btn"
              onClick={(e) => {
                e.stopPropagation();
                setShowLogoutConfirm(false); // ✅ ONLY CLOSE
              }}
            >
              Cancel
            </button>

            <button
              className="logout-confirm-btn"
              onClick={(e) => {
                e.stopPropagation();
                dispatch(logoutUser()); // ✅ logout only here
                navigate("/");
              }}
            >
              Logout
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default AccountManagement;
